const letters = /[a-zA-Z]/g;

// \u00C0 e \u017F aceita acentos !!!
const lettersAndSpaces = /[a-zA-Z\u00C0-\u017F\s]/g;

const lettersNumbersAndSpaces = /[a-zA-Z0-9\u00C0-\u017F\s]/g;

const numbers = /[0-9]/g;

const numbersAndSpaces = /[0-9\s]/g;

const email =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const noSpaces = /\S/g;

const cpf = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;

const sus = /^\d{3} \d{4} \d{4} \d{4}$/;

const cnpj = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

const pis = /^\d{3}\.\d{5}\.\d{2}-\d{1}$/;

const cellphone = /^\(\d{2}\) \d{5}-\d{4}$/;

const dn = /\d{10}/;

const height = /[0-9-,]{1,4}$/;

const weight = /[0-9-,]{1,6}$/;

const charRemove = /[^-._a-zA-Z\s.0-9]/g;

const addressForGoogleMaps = /[^-._,a-zA-Z\S.0-9,]/g;


const regexps = {
    letters,
    lettersAndSpaces,
    lettersNumbersAndSpaces,
    numbers,
    numbersAndSpaces,
    email,
    noSpaces,
    cpf,
    sus,
    cnpj,
    pis,
    cellphone,
    dn,
    height,
    charRemove,
    weight,
    addressForGoogleMaps
};

export default regexps;
